<template>
  <div class="common_wrap bg_grey color_black relative">
    <div
      v-if="status === 0"
      class="page ab_center fs_18"
    >
      活动未开始
    </div>
    <div
      v-else-if="status === 2 || (!isNew && !(userSign.oldSignGiftVos && userSign.oldSignGiftVos.length))"
      class="page ab_center fs_18"
    >
      活动已结束
    </div>
    <template v-else>
      <div class="header_img text_highlight">
        <img :src="require('@/assets/clockIn/headder.jpg')" />
      </div>
      <div class="main">
        <div class="top">
          <div class="top_card relative">
            <img src="https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/clockin_header.png" alt="每周签到礼">
            <div v-if="!isNew" class="top_card_tip color_white fs_12 scale08_bot mb_4">（每周一刷新）</div>
          </div>
          <div class="top_info bg_white relative round_5">
            <div class="top_title flex_between mb_8" style="align-items: baseline;">
              <div class="top_signday fs_16">
                已累计签到<span class="color_yellow fs_22 ml_4 mr_4">{{ totalSignDay }}</span>天
              </div>
              <div class="top_rule" @click="handleShowRule">
                <van-icon name="question" />
                活动规则
              </div>
            </div>
            <div
              class="top_signs"
              :style="{
                transform: `translateY(${isNew ? 0 : -16}px)`,
                height: isNew ? 'unset' : '96px',
              }"
            >
              <div
                v-if="isNew"
                class="gift_signs d_flex flex_between mb_8"
                :style="{
                  transform: `translateY(${!isNew ? 16 : 0}px)`
                }"
              >
                <div
                  v-for="i in newTopList"
                  :key="i.days"
                  class="gift_sign bg_grey d_flex_col flex_center round_5 relative"
                >
                  <div
                    class="gift_sign_icon bg_contain mb_10"
                    :class="{ op_5: i.drawStatus !== 1 }"
                    :style="{
                      backgroundImage: `url(${require('@/assets/clockIn/gift_icon.png')})`
                    }"
                  ></div>
                  <div
                    class="gift_sign_day fs_12 scale08_center"
                    :class="{ color_org: userSign.days === i.days }"
                  >第{{ i.days }}天</div>
                  <div
                    v-if="i.drawStatus === 1"
                    class="gift_has_clockin bg_contain"
                    :style="{
                      backgroundImage: `url(${require('@/assets/clockIn/get_icon.png')})`
                    }"
                  ></div>
                </div>
              </div>
              <div
                v-if="!isNew"
                class="gift_signs d_flex flex_between"
                :style="{
                  transform: `translateY(${!isNew ? 16 : 0}px)`
                }"
              >
                <div
                  v-for="i in newTopList"
                  :key="i.days"
                  class="gift_sign bg_grey d_flex_col flex_center round_5 relative"
                  :class="{
                    [`gift_sign_${i.days}`]: true
                  }"
                >
                  <div
                    class="gift_sign_icon bg_contain mb_10"
                    :class="{ op_5: i.drawStatus !== 1 }"
                    :style="{
                      backgroundImage: `url(${require('@/assets/clockIn/gift_icon.png')})`
                    }"
                  ></div>
                  <div
                    class="gift_sign_day fs_12 scale08_center"
                  >第{{ i.days }}天</div>
                  <div
                    v-if="i.drawStatus === 1"
                    class="gift_has_clockin bg_contain"
                    :style="{
                      backgroundImage: `url(${require('@/assets/clockIn/get_icon.png')})`
                    }"
                  ></div>
                </div>
              </div>
              <div class="top_steps" v-if="!isNew">
                <Steps
                  finish-icon="checked"
                  inactive-icon="circle"
                  :active="userSign.totalSignDay - 1"
                  active-color="#FF5043"
                >
                  <Step v-for="i in 7" :key="i">
                  </Step>
                </Steps>
              </div>
            </div>
            <div class="top_sign_btn">
              <van-button
                color="#ff5043"
                round
                block
                :disabled="actInfo.sign"
                @click="handleSignIn"
              >
                <span class="bold">{{ actInfo.sign ? '今日已签到' : '点我签到' }}</span>
              </van-button>
            </div>
          </div>
        </div>
        <div class="gift_list mt_8">
          <div
            v-for="(gf, gfIdx) in giftList"
            :key="gf.giftId + '' + gfIdx"
            class="gift bg_white round_5"
          >
            <gift-item-1
              :icon="gf.giftIcon"
              :desc="gf.desc"
              :name="gf.giftName"
              :btnText="getBtnText(gf)"
              :disabled="!['领取', '今天可领'].includes(getBtnText(gf)) "
              @receive="handleReceiveGift(gf)"
              @disableClick="handleClickDisable(gf)"
            />
          </div>
        </div>
        <div  
          v-if="!isNew"
          class="bottom_img round_5 bg_contain mt_6"
          @click="handleClickAdPic"
        >
          <img class="round_5" :src="userSign.advertiseUrl" />
        </div>
        <!-- 老用户配置可能为空 -->
        <template v-if="isNew && userSign.oldSignGiftVos && userSign.oldSignGiftVos.length">
          <div class="top mt_8">
            <div class="top_card relative">
              <img src="https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/clockin_billboard_new.png" alt="每周签到礼">
            </div>
          </div>
          <div class="gift_mask_wrap relative">
            <div class="gift_list mt_8">
              <div
                v-for="(gf, gfIdx) in userSign.oldSignGiftVos"
                :key="gf.giftId + '' + gfIdx"
                class="gift bg_white round_5"
              >
              <!-- FAKE -->
              <gift-item-1
                :icon="gf.giftIcon"
                :desc="gf.desc"
                :name="gf.giftName"
              />
              </div>
            </div>
            <div class="gift_mask" @click.stop />
            <div class="unlock ab_center">
              <div class="circle flex_center">
                <van-icon name="lock" color="#FFF" />
              </div>
              <div class="fs_16">{{ 7 - ((userSign.days || 1) - 1) }}天后解锁</div>
            </div>
          </div>
        </template>
      </div>
      <EnterPopup ref="enterRef" :isNew="isNew" @ok="handleEnterOk" />
      <RulePopup
        ref="ruleRef"
        :ruleText="actInfo.rule"
      />
      <Popup
        :visible.sync="visible"
        v-bind="feedback"
        @confirm="feedback.onSure"
        @cancel="feedback.onCancel"
      >
        <template v-if="feedbackType === 0">
          <div class="color_normal text_center">今日签到即可领取</div>
          <gift-item-1 hideBtn />
        </template>
        <template v-if="feedbackType === 1">
          <template v-if="nextGift.giftId">
            <div class="color_normal text_center">明日签到可再领</div>
            <gift-item-1
              :icon="nextGift.giftIcon"
              :desc="nextGift.desc"
              :name="nextGift.giftName"
              hideBtn
            />
          </template>
          <div class="color_normal text_center fs_12 scale08_center">
            <p>礼包码已存放在</p>
            <p>【我的礼包】--【常规礼包】</p>
          </div>
        </template>
        <template v-if="feedbackType === 2">
          <div class="color_normal text_center fs_12 scale08_center">
            <p>礼包码已存放在</p>
            <p>【我的礼包】--【常规礼包】</p>
          </div>
        </template>
      </Popup>
    </template>
  </div>
</template>
<script>
import { openLoading } from '@/components/Loading';
import { getSignInHome, signInActionApi, signInReceive } from '@/apis/activity.api'
import GiftItem1 from '@/components/gift/giftItem1.vue';
import EnterPopup from './EnterPopup.vue';
import RulePopup from '@/components/RulePopup.vue';
import Popup from '@/components/Popup.vue';
import { Step, Steps } from 'vant'
import store from "@/store";
import trackingMixin, { EVENT_TYPE_ENUM } from "@/mixins/tracking"; 
export default {
  components: {
    GiftItem1,
    EnterPopup,
    Popup,
    Step,
    Steps,
    RulePopup,
  },
  mixins: [trackingMixin],
  data () {
    return {
      actInfo: {},
      status: 1,
      clockDay: 2,
      visible: false,
      feedbackType: 0,
      receiveLoading: false,
      nextGift: {}, // 下一个可领取的礼包
      nextGetTime: '',
      activityId: '',
      curGift: {},
    }
  },
  mounted () {
    try {
      const params = JSON.parse(localStorage.getItem('wxAuthQuery'))
      this.activityId = this.$route.query.activityId || params.activityId
    } catch (error) {
      this.$toast('参数获取失败')
    }
    this.init()
  },
  computed: {
    isNew () {
      return this.actInfo.userType === 1
    },
    userSign () {
      const { newUserSignVo = {}, oldUserSignVo = {}, userType } = this.actInfo
      return userType === 1 ? newUserSignVo : oldUserSignVo
    },
    totalSignDay () {
      const { totalSignDay, signDays } = this.userSign
      return this.isNew ? signDays.length : totalSignDay
    },
    // 第一部分的礼包列表
    giftList () {
      return this.userSign[this.isNew ? 'newSignGiftVos' : 'oldSignGiftVos'] || []
    },
    // 新用户顶部天数列表
    newTopList () {
      const list = JSON.parse(JSON.stringify(this.giftList))
      return list.sort((a, b) => a.days - b.days)
    },
    feedbackMap () {
      return [
        {
          title: '忘记签到啦!',
          confirmButtonText: '一键签到',
          message: [],
          onCancel: () => {},
          onSure: () => {
            this.handleSignIn().finally(() => {
              this.triggerVisible(false)
            })
          }
        },
        {
          title: '领取成功',
          confirmButtonText: '去复制礼包码',
          showCancelButton: true,
          cancelButtonText: '再看看',
          message: [],
          onSure: () => {
            this.triggerVisible(false)
            this.handleGoMyGift()
          },
          onCancel: () => {
            const { giftId, days } = this.curGift
            this.EVENT_TRACKING(
              EVENT_TYPE_ENUM.wechat_sign_activity_know_button,
              {
                ...this.trackActInfo,
                gift_id: giftId,
                gift_name: this.getGiftNameByDays(days),
              },
              this.trackAppInfo
            )
            this.triggerVisible(false)
          }
        },
        {
          title: '领取成功',
          confirmButtonText: '去复制礼包码',
          showCancelButton: true,
          cancelButtonText: '我知道了',
          message: [],
          onSure: () => {
            this.triggerVisible(false)
            this.handleGoMyGift()
          },
          onCancel: () => {
            const { giftId, days } = this.curGift
            this.EVENT_TRACKING(
              EVENT_TYPE_ENUM.wechat_sign_activity_know_button,
              {
                ...this.trackActInfo,
                gift_id: giftId,
                gift_name: this.getGiftNameByDays(days),
              },
              this.trackAppInfo
            )
            this.triggerVisible(false)
          }
        },
      ]
    },
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    // 埋点所需的活动信息
    trackActInfo () {
      return {
        activity_id: this.activityId,
        activity_name: this.actInfo.name,
        user_type: this.isNew ? 1 : 2
      }
    },
    // 埋点所需的游戏信息
    trackAppInfo () {
      return {
        appkey: this.actInfo.gameId,
        appName: this.actInfo.gameName,
      }
    },
  },
  methods: {
    init () {
      this.getMainInfo()
    },
    getMainInfo (hasEvent = true) {
      return getSignInHome({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        activityId: this.activityId,
      }).then(res => {
        this.actInfo = res.data
        document.title = res.data.name || '签到活动'
        if (hasEvent) {
          this.EVENT_TRACKING(
            EVENT_TYPE_ENUM.wechat_sign_activity_home,
            this.trackActInfo,
            this.trackAppInfo
          )
        }
        this.handleEnterOnce()
      }).catch((error) => {
        const { code } = error
        if (code === 1097) {
          this.status = 2
        }
      })
    },
    // 用户进入页面 - 判断是否首次
    handleEnterOnce () {
      if (!this.$storeGet('ACT_SIGNIN_ONCE')) {
        this.$refs.enterRef.triggerVisible(true)
        this.$storeSet('ACT_SIGNIN_ONCE', 1)
        this.EVENT_TRACKING(
          EVENT_TYPE_ENUM.wechat_sign_activity_first_visit_pop,
          this.trackActInfo,
          this.trackAppInfo
        )
      }
    },
    handleEnterOk () {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_sign_activity_first_visit_pop_to_sign,
        this.trackActInfo,
        this.trackAppInfo
      )
    },
    handleShowRule () {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_sign_activity_rule_button,
        this.trackActInfo,
        this.trackAppInfo
      )
      this.$refs.ruleRef.triggerVisible(true)
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_sign_activity_rule_pop,
        this.trackActInfo,
        this.trackAppInfo
      )
    },
    // 签到动作
    handleSignIn () {
      return signInActionApi({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        activityId: this.activityId,
      }).then(res => {
        const { sign, userType, days, signDays, totalSignDay } = res.data
        this.$toast(`签到${sign ? '成功' : '失败'}`)
        if (userType === 1) {
          this.actInfo.sign = sign
          this.actInfo.newUserSignVo.days = days
          this.actInfo.signDays = signDays
          this.actInfo.totalSignDay = totalSignDay
        }
        this.EVENT_TRACKING(
          EVENT_TYPE_ENUM.wechat_sign_activity_sign_button,
          {
            ...this.trackActInfo,
            sign_before_days: totalSignDay - 1,
            sign_after_days: totalSignDay,
          },
          this.trackAppInfo
        )
        // 更新列表
        this.getMainInfo(false)
      })
    },
    handleClickDisable (gift) {
      const { days, drawStatus } = gift
      this.curGift = gift
      if (drawStatus !== 1) return
      this.receiveGiftCallback(days)
    },
    receiveGiftCallback (days) {
      // 找到下一个礼包
      if (this.isNew) {
        this.nextGift = this.userSign.newSignGiftVos.find(v => v.days === days + 1) || {}
        this.feedbackType = 1
      } else {
        // 计算老用户的下个礼包，暂时不用
        // const currentIdx = this.userSign.oldSignGiftVos.findIndex(v => v.days === days)
        // this.nextGift = this.userSign.oldSignGiftVos[currentIdx + 1] || {}
        // if (this.nextGift.giftId) {
        //   const gap = this.nextGift.days - this.totalSignDay
        //   if (gap > 0) {
        //     this.nextGetTime = gap === 1 
        //   }
        // }
        this.feedbackType = 2
      }
      this.triggerVisible(true)
    },
    // 领取礼包
    handleReceiveGift (gift = {}) {
      const { giftId, days } = gift
      this.curGift = gift
      if (this.receiveLoading) return
      this.receiveLoading = true
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_sign_activity_draw_gift_button,
        {
          ...this.trackActInfo,
          gift_id: giftId,
          gift_name: this.getGiftNameByDays(days),
        },
        this.trackAppInfo
      )
      signInReceive({
        userType: this.actInfo.userType,
        wxappid: this.$storeGet('WX_APP_ID'),
        drawDays: days,
        openid: store.getters['user/openid'],
        activityId: this.activityId,
      }).then(res => {
        const { cdk } = res.data
        if (cdk) {
          this.receiveGiftCallback(days)
          this.EVENT_TRACKING(
            EVENT_TYPE_ENUM.wechat_sign_activity_draw_gift_success_pop,
            {
              ...this.trackActInfo,
              gift_id: giftId,
              gift_name: this.getGiftNameByDays(days),
            },
            this.trackAppInfo
          )
          // 更新列表
          this.getMainInfo(false)
        } else {
          this.$toast('礼包码已领完')
        }
      }).finally(() => this.receiveLoading = false)
    },
    triggerVisible (v) {
      this.visible = v
    },
    getBtnText ({ days, drawStatus } = {}) {

      if (!this.isNew) {
        return drawStatus === 0 ? '领取' : '已领取'
      }
      
      const gap = this.userSign.days - days
      if (gap > 0) {
        return drawStatus === 2 ? '已失效' : '已领取'
      } else if (gap < 0) {
        if (gap === -1) return '明天可领'
        if (gap === -2) return '后天可领'
        return `第${days}天可领`
      } else {
        return drawStatus === 0 ? '今天可领' : '已领取'
      }
    },
    // 老用户点击底部活动广告位
    handleClickAdPic () {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_sign_activity_advertise,
        this.trackActInfo,
        this.trackAppInfo
      )
      setTimeout(() => {
        const url = this.userSign.jumpUrl
        if (!url) return;
        window.open(url, '_self')
      }, 150)
    },
    // 
    handleGoMyGift () {
      const { giftId, days } = this.curGift
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_sign_activity_copy_cdk_button,
        {
          ...this.trackActInfo,
          gift_id: giftId,
          gift_name: this.getGiftNameByDays(days),
        },
        this.trackAppInfo
      )
      this.$router.push({
        name: 'myGift',
        query: {
          tab: 1,
          gameId: this.actInfo.gameId,
        }
      })
    },
    getGiftNameByDays (days) {
      if (this.isNew) return `第${days}天签到礼包`
      return `累计签到${days}天礼包`
    }
  },
}
</script>
<style lang="scss" scoped>
::v-deep .van-steps {
  overflow: unset;
}
::v-deep .van-steps--horizontal {
  padding-top: 0;
}
.header_img {
  width: 100%;
  height: 164px;
  position: absolute;
  top: 0;
  left: 0;
  img {
    width: 100%;
  }
}
.main {
  padding: 66px 10px 12px;
  overflow-x: hidden;
  overflow-y: auto;
}

.top {
  .top_info {
    padding: 8px;
  }
  .top_sign_btn {
    margin: 12px 36px 0;
  }
  .top_rule {
    filter: invert(.5);
    cursor: pointer;
  }
  .top_signs {
    .top_steps {
      padding: 0 12px;
    }
    .gift_signs {
      padding: 0 6px;
    }
    .gift_sign {
      padding: 6px 5px;
      color: #686868;
    }
    .gift_sign_3 {
      transform: translateX(5px);
    }
    .gift_sign_5 {
      transform: translateX(8px);
    }
    .gift_sign_icon {
      width: 34px;
      height: 34px;
    }
    .gift_has_clockin {
      position: absolute;
      top: 0px;
      right: 0px;
      width: 10px;
      height: 9px;
    }
  }
}
.top_card {
  img {
    width: 140px;
  }
  .top_card_tip {
    position: absolute;
    bottom: 0;
    left: 144px;
  }
}

.gift_list {
  overflow: auto;
  .gift {
    // padding: 8px 12px;
  }
  .gift + .gift {
    margin-top: 6px;
  }
}

.bottom_img {
  width: 100%;
  min-height: 66px;
  img {
    width: 100%;
  }
}

.gift_mask_wrap {
  padding: 8px 0;
  .gift_mask {
    position: absolute;
    top: 0;
    left: -10px;
    width: 100vw;
    height: 100%;
    background: #000;
    opacity: 0.4;
    z-index: 1;
  }
  .unlock {
    position: absolute;
    z-index: 2;
    display: flex;
    align-items: center;
    color: #fff;
  }
  .circle {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #FC5243;
    margin-right: 6px;
  }
}
</style>